import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap-v5';
import { KTSVG } from './KTSVG';

type Props = {
  show: boolean;
  confirmValue: (confirm: boolean) => void;
  onClose?: (closed: boolean) => void;
  title?: string;
  description?: string;
};

const ConfirmModal: React.FC<Props> = ({
  show,
  confirmValue,
  onClose,
  title = 'Confirmar acción',
  description = '¿Estás seguro de continuar con esta operación?',
}) => {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    setVisible(show);
  }, [show]);

  const handleCancel = () => {
    setVisible(false);
    confirmValue(false);
    onClose?.(false);
  };

  const handleConfirm = () => {
    setVisible(false);
    confirmValue(true);
    onClose?.(true);
  };

  return (
    <Modal
      show={visible}
      onHide={handleCancel}
      centered
      backdrop="static"
      animation
    >
      {/* Header con botón de cierre */}
      <Modal.Header className="border-0 justify-content-end">
        <div
          className="btn btn-sm btn-icon btn-active-color-primary"
          role="button"
          onClick={handleCancel}
        >
          <KTSVG
            className="svg-icon-2"
            path="/media/icons/duotune/arrows/arr061.svg"
          />
        </div>
      </Modal.Header>

      {/* Cuerpo del modal */}
      <Modal.Body className="text-center py-4">
        <h2 className="fw-bolder mb-3 text-gray-600">{title}</h2>
        <p className="text-muted fs-5">{description}</p>
      </Modal.Body>

      {/* Footer con acciones */}
      <Modal.Footer className="justify-content-center border-0 pb-4">
        <button className="btn btn-light" onClick={handleCancel}>
          Cancelar
        </button>
        <button className="btn btn-primary" onClick={handleConfirm}>
          Confirmar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export { ConfirmModal };
